import React from 'react';
import { Radar } from 'react-chartjs-2';
import { radarDefaults } from '../../utils/chartDefaults';
import {
    deepMerge,
    getChartColorAt,
    hexToRgba,
    isMissingColor,
} from '../../utils/chartHelpers';
import type { ChartDataLike } from '../../utils/chartHelpers';
import { palette } from '../../constants/colors';
import ChartFrame from './ChartFrame';

const applyRadarTheme = (data: ChartDataLike): ChartDataLike => {
    if (!data || !Array.isArray(data.datasets) || data.datasets.length === 0) return data;
    const dsCount = data.datasets.length;
    const datasets = data.datasets.map((ds, i) => {
        const next: any = { ...ds };
        const c = dsCount === 1 ? palette.primary : getChartColorAt(i);
        if (isMissingColor(ds.borderColor)) next.borderColor = c;
        if (isMissingColor(ds.backgroundColor)) {
            next.backgroundColor = ds.fill === false ? c : hexToRgba(c, 0.2);
        }
        if (isMissingColor(ds.pointBackgroundColor)) {
            next.pointBackgroundColor = dsCount === 1 ? palette.white : c;
        }
        if (isMissingColor(ds.pointBorderColor)) next.pointBorderColor = c;
        return next;
    });
    return { ...data, datasets };
};

export interface RadarChartProps {
    data: ChartDataLike;
    options?: any;
    className?: string;
    title?: string;
    badge?: string;
}

const RadarChart: React.FC<RadarChartProps> = ({ data, options, className, title, badge }) => {
    const merged = React.useMemo(() => deepMerge(radarDefaults, options || {}), [options]);
    const themed = React.useMemo(() => applyRadarTheme(data), [data]);
    return (
        <ChartFrame title={title} badge={badge} className={className}>
            <Radar data={themed as any} options={merged} />
        </ChartFrame>
    );
};

export default RadarChart;
